import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface BasicInfoSectionProps {
  control: Control<any>;
  contactMethods: { id: string; label: string }[];
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ control, contactMethods }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={8}>
        <Controller
          name="name"
          control={control}
          rules={{ required: 'Name is required' }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Full Name"
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth>
          <InputLabel>Preferred Contact</InputLabel>
          <Controller
            name="preferredMethod"
            control={control}
            render={({ field }) => (
              <Select {...field} label="Preferred Contact">
                {contactMethods.map(m => (
                  <MenuItem key={m.id} value={m.id}>{m.label}</MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default BasicInfoSection;
